module.exports = __webpack_public_path__ + "static/Children-7beb68202d523d48035b5d2eb04629df.png";